#import "../fragments/role-fragment.graphql"

mutation CreateRole($input: RoleCreateInput!) {
    roleCreate(input: $input) {
        role {
            ...RoleFragment
        }
    }
}
